export enum MilestoneValueType {
	rating = "Rating",
	confidence = "Confidence",
}
